module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-BE":{"tab_title":"Input Form","ing":{"tab_title":"ING Input Form"}},"fr-BE":{"tab_title":"Formulaire","ing":{"tab_title":"Formulaire ING"}},"nl-BE":{"tab_title":"Input Form","ing":{"tab_title":"ING Input Form"}}}')
  delete Component.options._Ctor
}
